<script>
import { mapGetters, mapActions } from 'vuex'
import stepsMixin from '../../mixins/stepsMixin'

export default {
	mixins: [stepsMixin],
	components: {
		BasicData: () => import('../../components/simulator/pf/forms/BasicData'),
		GeneralData: () => import(/* webpackChunkName: "generalData-v2" */ '../../components/simulator/pf/forms/GeneralData'),
		FinancialRisk: () => import(/* webpackChunkName: "FinancialRisk-v2" */ '../../components/simulator/pf/forms/FinancialRisk'),
		BusinessRisk: () => import(/* webpackChunkName: "BusinessRisk-v2" */ '../../components/simulator/pf/forms/BusinessRisk'),
		BankingRalationships: () => import(/* webpackChunkName: "BankingRalationships-v2" */ '../../components/simulator/pf/forms/BankingRalationships'),
		ApproachPf: () => import(/* webpackChunkName: "ApproachPf-v2" */ '../../components/simulator/pf/forms/ApproachPf'),
		PoliticsPf: () => import(/* webpackChunkName: "PoliticsPf-v2" */ '../../components/simulator/pf/forms/PoliticsPf'),
		ExecutiveSummary: () => import(/* webpackChunkName: "ExecutiveSummary-v2" */ '../../components/simulator/pf/forms/ExecutiveSummary'),
		PfLoader: () => import(/* webpackChunkName: "pf-loader" */ '../../components/simulator/pf/PfLoader'),
		PfModal: () => import(/* webpackChunkName: "pf-modal" */ '../../components/simulator/pf/PfModal'),
	},
	data() {
		return {
			pendingChanges: false,
			lastTab: null,
			cliente: {
				datos: {
					
				},
				hijos: [],
				estado: 'En curso - iniciado',
			},
			estado: 'En curso - iniciado',
			analisis: {
				resumen_ejecutivo: {
					avance: 0,
					datos: {
						
					}
				},
				datos_generales: {
					avance: 0,
					datos: {
						// ValoresGenerales
						analista_local: '',
						modalidad: '',
						analista: '',
						rating_comite: '',
						fecha_rating_comite: '',
						justificacion_rating_comite: '',
						resolucion_comite: '',
						fecha_resolucion_comite: '',
						observaciones_del_comite: '',
						analista_grm_wscr: '',
						analista_gcrc: '',
						banca_segmento: '',
						reestructuracion: '',
						sector: '',
						ambito_de_conformidad: '',
						subsector: '',
						criterio_de_aplicacion: '',
						actividad: '',
						// Caratula
						watch_list: '',
						refinanciado: '',
						calificacion: '',
						provision: '',
						acreditado_propuesto: '',
						areas_de_negocio: [
							{
								id:1,
								mexico: '',
								banca_empresas: '',
								bbva_bancomer: '',
							},
							{
								id:2,
								mexico: '',
								banca_empresas: '',
								bbva_bancomer: '',
							},
							{
								id:3,
								mexico: '',
								banca_empresas: '',
								bbva_bancomer: '',
							},
							{
								id:4,
								mexico: '',
								banca_empresas: '',
								bbva_bancomer: '',
							},
							{
								id:5,
								mexico: '',
								banca_empresas: '',
								bbva_bancomer: '',
							},
							{
								id:6,
								mexico: '',
								banca_empresas: '',
								bbva_bancomer: '',
							},
							{
								id:7,
								mexico: '',
								banca_empresas: '',
								bbva_bancomer: '',
							},
							{
								id:8,
								mexico: '',
								banca_empresas: '',
								bbva_bancomer: '',
							},
						],
						moneda_limites: [
							'',
							'',
							'',
							'',
						],
						limite_anterior: ['','','',''],
						limite_actual: ['','','',''],
						limite_nuevo: ['','','',''],
						riesgo_global: {
							area_gcrc: '',
							subarea_gcrc: '',
							area_participante: '',
						},
						// Leveraged Lending
						entidad_excluida_de_analisis_leveraged: '',
						motivo_exclusion_leveraged: '',
						indicador_tipo_analisis: '',
						rating_escala_corta: '',
						rating_ajustado_escala_corta: '',
						indicador_financial_sponsor: '',
						divisa_riesgo: '',
						unidad_divisa_riesgo: '',
						riesgo_total_grupo: '',
						total_mill_e: '',
						riesgo_potencial: '',
						potencial_mill_e: '',
						tipo_cambio: '',
						fecha_tipo_cambio: '',
						divisa_eeff: '',
						unidad_divisa_eeff: '',
						tipo_cambio_a_euro_eeff: '',
						fecha_eeff_test_leveraged: '',
						numero_empleados: '',
						facturacion: '',
						facturacion_mill_e: '',
						total_balance: '',
						balance_mill_e: '',
						deudas: '',
						ebitda: '',
						ratio_deuda_ebitda: '',
						deuda_leveraged: '',
						motivo_ajuste_deuda: '',
						leveraged_notas: '',
						
						ratio_deuda_ebitda_leveraged: '',
						pyme_segun_bce: '',
						tipo_covenants: '',
						cumplimiento_covenants: '',
						comentarios_sobre_incumplimiento_de_covenants: '',
						indicador_leveraged_sugerido: '',
						tipo_leveraged_sugerido: '',
						indicador_leveraged_ajustado: '',
						tipo_leveraged_ajustado: '',
						motivo_ajuste_leveraged: '',
						indicador_leveraed_pf_anterior: '',
						tipo_leveraged_pf_anterior: '',
						mot_var_marca_ll: '',
						filial_leverageds: [
							{
								filial_leveraged: '',
								indicador_subgrupo: '',
								rating_escala_corta: '',
								divisa_riesgo: '',
								unidad_de_riesgo: '',
							},
							{
								filial_leveraged: '',
								indicador_subgrupo: '',
								rating_escala_corta: '',
								divisa_riesgo: '',
								unidad_de_riesgo: '',
							},
							{
								filial_leveraged: '',
								indicador_subgrupo: '',
								rating_escala_corta: '',
								divisa_riesgo: '',
								unidad_de_riesgo: '',
							},
							{
								filial_leveraged: '',
								indicador_subgrupo: '',
								rating_escala_corta: '',
								divisa_riesgo: '',
								unidad_de_riesgo: '',
							},
						]
					}
				},
				datos_basicos: {
					avance: 0,
					datos: {
						notas: '',
						principales_accionistas: [
							{
								nombre: '',
								porcentaje: '',
								accionista_control: '',
								fecha_de_entrada: '',
								financial_sponsor: ''
							},
							{
								nombre: '',
								porcentaje: '',
								accionista_control: '',
								fecha_de_entrada: '',
								financial_sponsor: ''
							},
							{
								nombre: '',
								porcentaje: '',
								accionista_control: '',
								fecha_de_entrada: '',
								financial_sponsor: ''
							},
							
						],
						cotiza_en_bolsa: '',
						tipo_administracion_conducta: '',
						principales_filiales: [
							{
								nombre: '',
								porcentaje: '',
								consolidacion: '',
								sector_actividad: '',
							},
							{
								nombre: '',
								porcentaje: '',
								consolidacion: '',
								sector_actividad: '',
							},
							{
								nombre: '',
								porcentaje: '',
								consolidacion: '',
								sector_actividad: '',
							}
						],
						nota_principales_filiales: '',
						fecha_constitucion: '',
						actividad_principal: '',
						cliente_desde: '',
						cuenta_clave: '',
						pais_cabecera: '',
						rfc: '',
					}
				},
				business_risk: {
					avance: 0,
					datos: {
						mercado_productos: [
							{
								cliente: '',
								cliente_productos: '',
								nac_ext: '',
								ventas: '',
								proveedor: '',
								proveedor_productos: '',
								nac_imp: '',
								volumen: '',
								competidores: '',
								part_mdo: ''
							},
							{
								cliente: '',
								cliente_productos: '',
								nac_ext: '',
								ventas: '',
								proveedor: '',
								proveedor_productos: '',
								nac_imp: '',
								volumen: '',
								competidores: '',
								part_mdo: ''
							}
						],
						crs: 0,
						ciclo_economico: '',
						posicion_cometitiva_y_valoracion: 'lorem lorem'
					}
				},
				financial_risk: {
					avance: 0,
					datos: {
						estructura: []
					}
				},
				relaciones_bancarias: {
					avance: 0,
					datos: {
						pool_bancario_fecha: '',
						pool_bancario: [
							{
								banco: '',
								informacion_cliente_cp: '',
								informacion_cliente_cp_p: '',
								informacion_cliente_lp: '',
								informacion_cliente_lp_p: '',
								otras_empresas_cp: '',
								otras_empresas_cp_p: '',
								otras_empresas_lp: '',
								otras_empresas_lp_p: '',
							},
							{
								banco: '',
								informacion_cliente_cp: '',
								informacion_cliente_cp_p: '',
								informacion_cliente_lp: '',
								informacion_cliente_lp_p: '',
								otras_empresas_cp: '',
								otras_empresas_cp_p: '',
								otras_empresas_lp: '',
								otras_empresas_lp_p: '',
							},
							{
								banco: '',
								informacion_cliente_cp: '',
								informacion_cliente_cp_p: '',
								informacion_cliente_lp: '',
								informacion_cliente_lp_p: '',
								otras_empresas_cp: '',
								otras_empresas_cp_p: '',
								otras_empresas_lp: '',
								otras_empresas_lp_p: '',
							},
							{
								banco: '',
								informacion_cliente_cp: '',
								informacion_cliente_cp_p: '',
								informacion_cliente_lp: '',
								informacion_cliente_lp_p: '',
								otras_empresas_cp: '',
								otras_empresas_cp_p: '',
								otras_empresas_lp: '',
								otras_empresas_lp_p: '',
							},
						],
						cuota_bancaria_bbva: '',
						comentarios_pool_bancario: '',
						cesiones_de_negocio_y_rentabilidad: '',
						detalle_riesgos_de_tesoreria: '',
						buro_de_credito: [
							{
								buro_de_credito: '',
								fecha: '',
								clave_de_prevencion: '',
								no_bancos: '',
								mn: '',
								dls_val: '',
								udis_val: '',
								total: '',
								hasta_30_d: '',
								hasta_90_d: '',
								mas_90_d: '',
							}
						],
						comentario_buro_de_credito: '',
						watch_list: 'WL 1',
						refinanciado: '',
						calificacion: '',
						provision: '',
					}
				},
				planteamiento: {
					avance: 0,
					datos: {
						debilidades_amenazas_fortalezas_oportunidades: '',
						conclusiones: ''
					}
				},
				politicas: {
					avance: 0,
					datos: {
						estructura: []
					}
				},
			}
		}
	},

	computed: {
		printMenu() {
			return [{
				nombre: 'Programa Financiero',
				tipo: 'folder',
				hijos: [
					{
						nombre: 'Carátula',
						tipo: 'file',
						hijos: []
					},
					{
						nombre: 'Índice',
						tipo: 'file',
						hijos: []
					},
					{
						nombre: 'Datos Generales',
						tipo: 'file',
						hijos: []
					},
					{
						nombre: 'Leveraged',
						tipo: 'file',
						hijos: []
					},
					{
						nombre: 'Resumen Ejecutivo',
						tipo: 'file',
						hijos: []
					},
					{
						nombre: 'Datos Básicos',
						tipo: 'folder',
						hijos: [
							{
								nombre: 'Identificación',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Accionariado',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Participaciones Significativas / Organigrama',
								tipo: 'file',
								hijos: []
							},
						]
					},
					{
						nombre: 'Business Risk',
						tipo: 'folder',
						hijos: [
							{
								nombre: 'Mercado productos',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Posición Competitiva y Valoración',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Concentración: Cliente / Proveedores',
								tipo: 'file',
								hijos: []
							},
						]
					},
					{
						nombre: 'Financial Risk',
						tipo: 'folder',
						hijos: this.getFinancialRiskPrint()
					},
					{
						nombre: 'Relaciones Bancarias',
						tipo: 'folder',
						hijos: [
							{
								nombre: 'Pool Bancario',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Cesiones de Negocio y Rentabilidad',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Detalle de Riesgos de Tesorería (Productos, importes, plazos)',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Información de Buró de Crédito',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Watch-List / Refinanciación / Calificación Contable',
								tipo: 'file',
								hijos: []
							},
						]
					},
					{
						nombre: 'Planteamiento',
						tipo: 'folder',
						hijos: [
							{
								nombre: 'Factores de riesgo',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Conclusiones',
								tipo: 'file',
								hijos: []
							},
						]
					},
					{
						nombre: 'Políticas',
						tipo: 'folder',
						hijos: this.getPoliticsPrint()
					},
					{
						nombre: 'Adjuntos (sólo documentos en formato .PDF)',
						tipo: 'folder',
						hijos: []
					},
				]
			}]
		},
		...mapGetters({
			'pf': 'pfAnalysis/pf',
			'getClientById': 'pfClients/getById',
			'userCode': 'auth/userCode'
		})
	},


	watch: {
		pf: {
			handler(newData) {
				if(!newData) {
					return 
				}
				debugger
				this.setAnalysis(newData.analysis)
				let client = JSON.stringify(this.getClientById(newData.client_id))
					client = JSON.parse(client)
				client.estado = newData.status
				this.$set(this, 'cliente', client)
				this.setClientToPolitics()
				this.setClientFinancialRisk()
				// this.cliente = this.getClientById(newData.client_id)
			},
			deep: true
		}
	},


	methods: {
		async getXLSXData() {
			this.$refs.loaderModal.open()
			let cliente = JSON.stringify(this.cliente.datos)
				cliente = JSON.parse(cliente)
			let vm = this

			let data2 = {
				analisis: vm.analisis,
				cliente: vm.cliente,
				userCode: vm.userCode
			}	

			debugger
			try {
				
			
			let sheets = [
				
				{
					name: 'Cliente',
					data: this.rowsClient(cliente)
				},
				{
					name: 'Datos Generales',
					data: this.rowsGeneralData(this.analisis.datos_generales)
				},
				{
					name: 'Datos Básicos',
					data: this.rowsBasicData(this.analisis.datos_basicos)
				},
				{
					name: 'Business Risk',
					data: this.rowsBusinessRisk(this.analisis.business_risk)
				},
				{
					name: 'Financial Risk',
					data: this.rowsFinancialRisk(this.analisis.financial_risk)
				},
				{
					name: 'Relaciones Bancarias',
					data: this.rowsBankRelationships(this.analisis.relaciones_bancarias)
				},
				{
					name: 'Planteamiento',
					data: this.rowsApproach(this.analisis.planteamiento)
				},
				{
					name: 'Politícas',
					data: this.rowsPolitics(this.analisis.politicas )
				},
			]

			// let res = await fetch('https://bbvaxlsx.appssoriano-ariza.com/export/pdf', {
			// let res = await fetch('https://bbvaxlsx.sorianoariza.com/export', {
			let res = await fetch('https://bbvaxlsx.sorianoariza.com/export', {
				method: 'POST',
				headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
				},
				body: JSON.stringify({data: data2})
			})
		 
			let { link }  = await res.json()
			debugger

			this.downloadURI(link)

			} catch (error) {
				this.$refs.loaderModal.close()
			}

		},

		downloadURI(uri) {
			debugger

			var link = document.createElement("a");
			link.href = uri;
			link.target = "_blank"
			link.download = "pdf"
			document.body.appendChild(link);
			link.click();
			// document.body.removeChild(link);
			link.remove()
			this.$refs.loaderModal.close()
		},

		rowsClient(cliente) {

			delete cliente.id
			delete cliente.parent
			delete cliente.buro
			delete cliente.cash_flow
			delete cliente.informes
			delete cliente.magnitudes_y_ratios
			delete cliente.politicas
			delete cliente.rating
			delete cliente.rating_local

			let rows  = []
			rows.push(['Participante:',  this.userCode])

			Object.keys(cliente).forEach(key => {
				let row = []

				if(!rows.length) {

					row.push(key+':')
					row.push(cliente[key])
					row.push('')
					rows.push(row)
					return
				}

				row = rows[rows.length - 1]

				if(row.length < 5) {
					row.push(key+':')
					row.push(cliente[key])
					row.push('')
					rows[rows.length - 1] =  row

					return
				}

				row = []
				row.push(key+':')
				row.push(cliente[key])
				row.push('')

				rows.push(row)
				return

			});  
			
			return rows
		},

		rowsGeneralData(analisis) {
			analisis = JSON.stringify(analisis)
			analisis = JSON.parse(analisis)
			let rows  = []
			let areas_de_negocio = analisis.datos.areas_de_negocio
			let limite_actual = analisis.datos.limite_actual
			let limite_anterior = analisis.datos.limite_anterior
			let limite_nuevo = analisis.datos.limite_nuevo
			let moneda_limites = analisis.datos.moneda_limites
			let riesgo_global = JSON.stringify(analisis.datos.riesgo_global)
				riesgo_global = JSON.parse(riesgo_global)
			rows.push(['Avance:',  analisis.avance + '%', "", "", "", ""])

			delete analisis.datos.areas_de_negocio
			delete analisis.datos.limite_actual
			delete analisis.datos.limite_anterior
			delete analisis.datos.limite_nuevo
			delete analisis.datos.moneda_limites
			delete analisis.datos.riesgo_global

			let datos = analisis.datos
			Object.keys(datos).forEach(key => {
				let row = []

				if(!rows.length) {

					row.push(key+':')
					row.push(datos[key])
					row.push('')
					rows.push(row)
					return
				}

				row = rows[rows.length - 1]

				if(row.length < 5) {
					row.push(key+':')
					row.push(datos[key])
					row.push('')
					rows[rows.length - 1] =  row

					return
				}

				row = []
				row.push(key+':')
				row.push(datos[key])
				row.push('')

				rows.push(row)
				return

			}); 

			rows.push(["", "", "", "", ""])
			rows.push(['Carátula', "", "", ""])
			rows.push(['Áreas de Negocio', "", "", ""])

			areas_de_negocio.forEach((item, index) => {
				rows.push([' Banco/Área Negocio ' + (index + 1), item.mexico, item.banca_empresas, item.bbva_bancomer])
			})

			
			rows.push(["", "", "", "", ""])
			rows.push(["Limites", "", "", "", ""])
			rows.push(["", "ACREDITADO PROPUESTO", "", "GRUPO", "CE"])
			rows.push(['', moneda_limites[0], moneda_limites[1], moneda_limites[2], moneda_limites[3]])
			rows.push(['LÍMITE ANTERIOR', limite_anterior[0], limite_anterior[1], limite_anterior[2], limite_anterior[3]])
			rows.push(['LÍMITE ACTUAL', limite_actual[0], limite_actual[1], limite_actual[2], limite_actual[3]])
			rows.push(['LÍMITE NUEVO', limite_nuevo[0], limite_nuevo[1], limite_nuevo[2], limite_nuevo[3]])
		
			rows.push(["", "", "", "", ""])
			rows.push(["","", "BANCO BILBAO VIZCAYA ARGENTARIA", "", "", ""])
			rows.push(["","", "GLOBAL RISK MANAGEMENT", "", "", ""])
			rows.push(["","", "GCR - GESTIÓN CORPORATIVA DE RIESGO DE CRÉDITO", "", "", ""])
			rows.push(["","", "ÁREA GCRC: " + riesgo_global.area_gcrc, "", "", ""])
			rows.push(["","", "SUBÁREA GCRC: " + riesgo_global.subarea_gcrc, "", "", ""])
			rows.push(["","", "SUBÁREA PARTICIPANTE: " + riesgo_global.area_participante, "", "", ""])
		
			return rows
		},

		rowsBasicData(analisis) {
			analisis = JSON.stringify(analisis)
			analisis = JSON.parse(analisis)
			let rows = []
			let cliente = this.cliente.datos

			rows.push(['Datos Básicos' + analisis.avance + '%'])
			rows.push([''])
			rows.push(['Identificación'])
			rows.push([''])
			rows.push(['Nombre:', cliente.nombre, '', 'Fecha de Constitución:', cliente.fecha_constitucion])
			rows.push(['Actividad pricipal/Calve Banxico:', cliente.actividad_principal, '', 'Cliente desde:', cliente.cliente_desde])
			rows.push(['País Cabecera:', cliente.pais_cabecera, '', 'Cta. Clave:', cliente.cuenta_clave])
			rows.push(['RFC:', cliente.rfc])
			rows.push([''])
			rows.push(['Notas:', analisis.datos.notas])

			rows.push([''])
			rows.push(['Accionariado'])
			rows.push([''])
			analisis.datos.principales_accionistas.forEach(a => {
				rows.push([a.nombre, a.porcentaje, a.fecha_de_entrada, a.financial_sponsor, a.accionista_control])
			})
			rows.push([''])

			rows.push(['Cotiza en Bolsa:', analisis.datos.cotiza_en_bolsa])
			rows.push(['Tipo de Administración / Conducta:', analisis.datos.tipo_administracion_conducta])

			rows.push([''])
			rows.push(['Participaciones Significativas'])
			rows.push([''])
			analisis.datos.principales_filiales.forEach(a => {
				rows.push([a.nombre, a.porcentaje, a.consolidacion, a.sector_actividad])
			})

			rows.push(['Notas Participaciones Significativas', analisis.datos.nota_principales_filiales])

			rows.push([''])

			return rows
		},

		rowsBusinessRisk(analisis) {
			let rows = []
			rows.push(['Business Risk ' + analisis.avance + '%'])
			rows.push([''])
			rows.push(['Mercado Productos'])
			rows.push([''])
			rows.push(['CLIENTES', 'PRODUCTOS', 'NAC/EXT', '% VENTAS', 'PROVEEDORES', 'PRODUCTOS', 'NAC/IMP', '% VOLUMEN', 'COMPETIDORES', '% PART. MDO.'])
			analisis.datos.mercado_productos.forEach(item => {
				rows.push([item.cliente, item.cliente_productos, item.nac_ext, item.ventas, item.proveedor, item.proveedor_productos, item.nac_imp, item.volumen, item.competidores, item.part_mdo])
			})
 
			rows.push([''])
			rows.push(['CRS: ', analisis.datos.crs, '', 'Ciclo Económico:', analisis.datos.ciclo_economico])

			rows.push([''])
			rows.push(['Posición Competitiva y Valoración'])
			rows.push([analisis.datos.posicion_cometitiva_y_valoracion])

			return rows

		},

		rowsFinancialRisk(analisis) {
			let rows = []
			rows.push(['Financial Risk ' + analisis.avance + '%'])
			rows.push([''])

			analisis.datos.estructura.forEach(c => {
				rows.push(['-----------','-----------','-----------','-----------','-----------','-----------','-----------',])
				rows.push([''])
				rows.push(['CLIENTE: ' + c.nombre])

				rows.push(['Síntesis económico financiera'])
				rows.push([''])
	
				rows.push(['Consolidado:', c.datos.consolidado, '', 'Salvedades:', c.datos.salvedades])
				rows.push(['Auditor:', c.datos.auditor, ])
				rows.push(['Divisa:', c.datos.divisa])
				rows.push(['Tipo de cambio a euro (€):', c.datos.tipo_de_cambio_a_euro, '', 'Tipo de cambio ($)', c.datos.tipo_de_cambio_dolar])
				rows.push(['Comentarios perímetro de consolidación y Salvedades:'])
				rows.push([c.datos.comentario_perimetro_de_consolidacion_salvedades])
				rows.push([''])


				rows.push(['Balance'])
				rows.push([''])

				rows.push(['Datos en:', c.datos.balance_datos_en, '', 'Divisa:', c.datos.balance_divisa])

				rows.push([''])


				if(c.datos.informes.length) {
					if(c.datos.informes[0].balance) {
						let row_h = ['']
						c.datos.informes.forEach((item, index) => {
							row_h.push(item.fecha)
							row_h.push('%')
						})

						rows.push(row_h)

						rows.push(['ACTIVOS'])

						c.datos.informes[0].balance.activo.forEach((a, index_a) => {
							let row_a = [a.titulo]
							
							c.datos.informes.forEach((i, index_i) => {
								console.log(i)
								if(i.balance.activo[index_a]) {
									row_a.push(i.balance.activo[index_a].monto)

								}
								if(i.balance.activo[index_a]) {
									row_a.push(i.balance.activo[index_a].porcentaje)
								}
							})

							rows.push(row_a)
						})

						rows.push(['PASIVOS'])

						c.datos.informes[0].balance.pasivo.forEach((a, index_a) => {
							let row_a = [a.titulo]
							console.log(a)
							c.datos.informes.forEach((i, index_i) => {
								if(i.balance.pasivo[index_a]) {
									row_a.push(i.balance.pasivo[index_a].monto)
									row_a.push(i.balance.pasivo[index_a].porcentaje)
								}
							})
							rows.push(row_a)
						})

					}

				}

				rows.push([''])
				rows.push(['Cuenta de resultados'])
				rows.push([''])

				rows.push(['Datos en:', c.datos.cuenta_resultados_datos_en, '', 'Divisa:', c.datos.cuenta_resultados_divisa])

				if(c.datos.informes.length) {
					let row_h = ['']
					c.datos.informes.forEach((item, index) => {
						row_h.push(item.fecha)
						row_h.push('%')
					})

					rows.push(row_h)


					c.datos.informes[0].cuenta_resultados.forEach((a, index_a) => {
						let row_a = [a.titulo]
						
						c.datos.informes.forEach((i, index_i) => {
							if(i.cuenta_resultados[index_a]) {
								row_a.push(i.cuenta_resultados[index_a].monto)
								row_a.push(i.cuenta_resultados[index_a].porcentaje)
							}
						})

						rows.push(row_a)
					})
				}

				if(c.cash_flow.length) {
					rows.push([''])
					rows.push(['Cash Flow'])
					rows.push([''])
	
	
					rows.push(['Datos en:', c.datos.cash_flow_datos_en, '',  'Divisa:', c.datos.cash_flow_divisa])
	
					let row_c_h = ['']
					c.cash_flow.forEach((item, index) => {
						row_c_h.push(item.ano)
					})
					rows.push(row_c_h)

					c.cash_flow[0].datos.forEach((a, index_a) => {
						let row_a = [a.titulo]
						
						c.cash_flow.forEach((i, index_i) => {
							row_a.push(i.datos[index_a].monto)
						})

						rows.push(row_a)
					})
				}

				if(c.magnitudes_y_ratios.length) {
					rows.push([''])
					rows.push(['Magnitudes y ratios'])
					rows.push([''])	

					rows.push(['Datos en:', c.datos.magnitudes_ratios_datos_en, '',  'Divisa:', c.datos.magnitudes_ratios_divisa])


					let row_c_h = ['']
					c.magnitudes_y_ratios.forEach((item, index) => {
						row_c_h.push(item.ano)
					})
					rows.push(row_c_h)

					c.magnitudes_y_ratios[0].datos.forEach((a, index_a) => {
						let row_a = [a.titulo]
						
						c.magnitudes_y_ratios.forEach((i, index_i) => {
							row_a.push(i.datos[index_a].monto)
						})

						rows.push(row_a)
					})
				}
				rows.push([''])
				rows.push(['Comentarios'])
				rows.push([''])
				rows.push(['Comentarios a la situación financiera, economica y valoración global'])
				rows.push([c.datos.comentarios_a_la_situacion_financiera_economica_y_valoracion_global])
				rows.push([''])
				rows.push(['Comentarios sobre cash-flow, magnitudes y ratios, flexibilidad financiera y liquidez'])
				rows.push([c.datos.comentarios_sobre_cash_flow_magnitudes_y_ratios_flexibidad_y_liquidez])

				rows.push([''])
				rows.push(['Rating'])
				
				let row_r_h = ['']

				c.rating.forEach((r, index) => {
					row_r_h.push('12/' + r.ano)
				})

				rows.push(row_r_h)

				let row_r_s = ['Score']
				let row_r_sm = ['ESCALA MAESTRA']
				let row_r_sl = ['Escala Larga']

				c.rating.forEach((a, index_a) => {
					row_r_s.push(a.score)
					row_r_sm.push(a.escala_maestra)
					row_r_sl.push(a.escala_larga)
				})

				rows.push(row_r_s)
				rows.push(row_r_sm)
				rows.push(row_r_sl)

				rows.push([''])

				rows.push(['Valoración del rating y ajuste del rating'])
				rows.push([c.datos.valoracion_del_rating_y_ajuste_del_rating])

				rows.push([''])
				rows.push(['Información de Rating Local'])

				rows.push(['INFORMACIÓN DE RATING LOCAL'])
				rows.push(['NOMBRE', 'NÚMERO DE CTE. PU.', 'FACHA EJERCICIO', 'PUNTUACIÓN CUANTITATIVA', 'PUNTUACIÓN CUALITATIVA', 'PUNTUACIÓN TOTAL', 'ESCALA ACTUAL', 'ESCALA ANTERIOR'])
				
				c.rating_local.forEach((r, index) => {
					rows.push([r.nombre, '', r.fecha, r.puntuacion_cuantitativa, r.puntuacion_cualitativa, r.puntuacion_tital, r.escala_actual, r.escala_anterior])
				})

				rows.push([''])
				rows.push(['Proyecciones/Análisis de Sensibilidad'])
				rows.push([c.datos.proyecciones_analisis_de_sensibilidad])

				rows.push([''])
			})

			return rows
		},

		rowsBankRelationships(analisis) {
			let rows = []
			rows.push(['Relaciones Bancarias ' + analisis.avance + '%'])
			rows.push([''])
			rows.push(['Pool Bancario'])

			rows.push(['CONCENTRACION DE PASIVO BANCARIO:', 'FECHA:' + analisis.datos.pool_bancario_fecha])
			rows.push(['(CUOTA DE BANQUERO)', 'INFORMACIÓN DEL CLIENTE', '', '', 'OTRAS EMPRESAS GPO.'])
			rows.push(['BANCO', 'C.P.', '%', 'L.P', '%', 'C.P.', '%', 'L.P', '%'])

			analisis.datos.pool_bancario.forEach(b => {
				rows.push([
					b.banco, 
					b.informacion_cliente_cp, 
					b.informacion_cliente_cp_p, 
					b.informacion_cliente_lp, 
					b.informacion_cliente_lp_p,
					b.otras_empresas_cp, 
					b.otras_empresas_cp_p, 
					b.otras_empresas_lp, 
					b.otras_empresas_lp_p
				])
			})

			rows.push([''])

			rows.push(['CUOTA BANCARIA BBVA %:' + analisis.datos.cuota_bancaria_bbva])

			rows.push(['Notas Pool Bancario'])
			rows.push([analisis.datos.comentarios_pool_bancario])

			rows.push([''])
			rows.push(['CESIONES DE NEGOCIO Y RENTABILIDAD'])
			rows.push([analisis.datos.cesiones_de_negocio_y_rentabilidad])
			
			rows.push([''])
			rows.push(['Detalle Riesgo de Tesoreía'])
			rows.push([analisis.datos.detalle_riesgos_de_tesoreria])
			
			rows.push([''])
			rows.push(['Información de Buró de Crédito'])
			rows.push([''])

			rows.push(['BURÓ DE CRÉDITO', 'FECHA', 'CLAVE DE PREVENCIÓN', 'NO. BANCOS', 'M.N.', 'DLS. VAL.', 'UDIS. VAL', 'TOTAL', 'HASTA 30 D', 'HASTA 90 D', 'MAS DE 90 D'])
			
			let cliente = this.cliente.datos
			cliente.buro.forEach(b => {
				rows.push([b.buro_de_credito, b.fecha, b.clave_de_prevencion, b.no_bancos, b.mn, b.dls_val, b.udis_val, b.total, b.hasta_30_d, b.hasta_90_d, b.mas_90_d])
			})

			rows.push(['Comentario'])
			rows.push([analisis.datos.comentario_buro_de_credito])
			rows.push([''])

			rows.push(['Watch-List/Refinanción/Calificación Contable'])
			rows.push([''])
			rows.push(['Wacth-List: ' + analisis.datos.watch_list, 'Refinanciado: ' + analisis.datos.refinanciado, 'Calificación: ' + analisis.datos.calificacion, '% Provisión: ' + analisis.datos.provision])


			return rows

		},

		rowsApproach(analisis) {
			let rows = []
			rows.push(['Planteamiento ' + analisis.avance + '%'])
			rows.push(['']) 
			rows.push(['Factores de riesgo'])
			rows.push(['']) 
			rows.push(['Debilidades / Amenazas / Fortalezas / Oportunidades:']) 
			rows.push([analisis.datos.debilidades_amenazas_fortalezas_oportunidades]) 
			
			rows.push(['']) 
			rows.push(['Conclusiones'])
			rows.push(['']) 
			rows.push([analisis.datos.conclusiones]) 

			return rows
		},

		rowsPolitics(analisis) {
			let rows = []
			rows.push(['Políticas ' + analisis.avance + '%'])
			rows.push([''])

			analisis.datos.estructura.forEach(c => {
				rows.push(['-----------','-----------','-----------','-----------','-----------','-----------','-----------',])
				rows.push([''])
				rows.push(['CLIENTE: ' + c.nombre])
				rows.push([''])

				rows.push(['Política de riesgo'])

				rows.push(['Política:', c.datos.politica, '', 'F. Vencimiento (*):', c.datos.fecha_vencimiento])
				rows.push(['Datos en (*):', c.datos.politicas_datos_en, '', 'Divisa en (*):', c.datos.politicas_divisa])
				rows.push([''])

				rows.push(['', 'LÍMITE ANTERIOR', 'LÍMITE ACTUAL', 'DISPUESTO', 'LÍMITE NUEVO', 'NOTAS'])
				c.datos.politicas_datos.forEach(p => {
					rows.push([p.nombre, p.limite_anterior, p.limite_actual, p.dispuesto, p.limite_nuevo, p.notas])
				})

				rows.push([''])

				rows.push(['Propuesta de riesgo'])
				rows.push([c.datos.propuesta_de_riesgo])
				
				rows.push(['Detalle política de riesgo'])
				rows.push([''])
				rows.push(['SOCIENDADES', 'RATING', 'FECHA EJERCICIO', 'LTE. AUTORIZADO'])

				c.datos.sociedades.forEach(s => {
					rows.push([s.nombre, s.rating, s.fecha_ejercicio, s.lte_autorizado])
				})

				rows.push(['DETALLE DE LOS TECHOS AUTORIZADOS CON SUS RESPECTIVAS GARANTIAS'])

				rows.push([c.datos.detalle_de_los_techos_autorizados_con_sus_respectivas_garantias])


				rows.push(['PROYECTO DE INVERSIÓN:', c.datos.proyecto_de_inversion, '', 'ETAPAS', c.datos.etapas])
				rows.push(['CREDITO RELACIONADO:', c.datos.credito_relacionado, '', 'SUPUESTOS', c.datos.supuestos])
				rows.push(['PERSONA DE RELEVANCIA PÚBLICA:', c.datos.persona_de_relevancia_publica, '', '¿SE ESTÁN INCLUYENDO TODOS LOS RIESGOS DEL GRUPO CON LA INSTITUCIÓN?', c.datos.se_estan_incluyendo_todos_los_riesgos_del_grupo_con_la_institucion])


				rows.push([''])
				rows.push(['Política de delegación'])
				rows.push([''])

				rows.push(['Anterior Ámbito de Conformidad:', c.datos.anterior_ambito_de_conformidad, '', 'Próxima Revisión de riesgo:', c.datos.proxima_revision_de_riesgos])
				rows.push(['Motivo Próxima Revisión:', c.datos.motivo_proxima_revision])

				rows.push(['OFICINA/CR:', c.datos.oficina_cr, '', 'COMITÉ DE RIESGOS:', c.datos.comite_de_riesgos])
				rows.push(['DIRECTOR DE OFICINA:', c.datos.director_de_oficina, '', 'FECHA DE SANCIÓN:', c.datos.fecha_de_sancion])
				rows.push(['EJECUTIVO/UNIDAD GESTORA:', c.datos.ejecutivo_unidad_gestora, '', 'NOMBRE DEL CONSTRASTE:', c.datos.nombre_del_constraste])
				rows.push(['TIPO DE CAMBIO (USD):', c.datos.tipo_de_cambio_usd, '', 'DECISIÓN:', c.datos.decision])
				rows.push(['TIPO DE CAMBIO A EURO (EUR):', c.datos.tipo_de_cambio_a_euro])

				rows.push(['Comentarios Políticade delegación'])
				rows.push([c.datos.comentario_politica_de_delegacion])


				rows.push([''])
				rows.push(['Rentabilidad'])
				rows.push([''])

				rows.push(['Divisa:', c.datos.rentabilidad_divisa, '', 'Datos en:', c.datos.rentabilidad_datos_en])

				rows.push([''])

				rows.push(['', 'AUTORIZADO', 'ACTUAL', 'PROPUESTO'])
				rows.push(['LÍMITES'])
				c.datos.limites.forEach(l => {
					rows.push([l.nombre, l.autorizado, l.actual, l.propuesto])
				})
				rows.push(['PÉRDIDA ESPERADA'])
				c.datos.perdida_esperada.forEach(l => {
					rows.push([l.nombre, l.autorizado, l.actual, l.propuesto])
				})
				rows.push(['CAPITAL ECONÓMICO'])
				c.datos.capital_economico.forEach(l => {
					rows.push([l.nombre, l.autorizado, l.actual, l.propuesto])
				})

				rows.push([''])
				rows.push(['Valoración y opinión'])

				rows.push([c.datos.valoracion_y_opinion])
			})


			return rows
		},

		getFinancialRiskPrint () {
			return this.analisis.financial_risk.datos.estructura.map(item => {
				return {
						nombre: item.nombre,
						tipo: 'folder',
						hijos: [
							{
								nombre: 'Síntesis económico-financiera',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Comentarios',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Rating',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Información de Rating Local',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Proyecciones/Análisis de Sensibilidad',
								tipo: 'file',
								hijos: []
							},
						]
					}
			})
		},
		getPoliticsPrint () {
			return this.analisis.financial_risk.datos.estructura.map(item => {
				return {
						nombre: item.nombre,
						tipo: 'folder',
						hijos: [
							{
								nombre: 'Politica de riesgo',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Propuestas de Riesgo',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Detalle Política de Reisgo',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Gestión del Programa Financiero',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Rentabilidad',
								tipo: 'file',
								hijos: []
							},
							{
								nombre: 'Valoración y opinión',
								tipo: 'file',
								hijos: []
							},
						]
					}
			})
		},
		setClientToPolitics() {
			if(!this.analisis.politicas.datos.estructura.length) {
				let cliente = JSON.stringify(this.cliente.datos)
					cliente = JSON.parse(cliente)
				cliente.datos = {
					politica: '',
					politicas_datos_en: '',
					politicas_divisa: '',
					fecha_vencimiento: '',
					politicas_datos: [
						{
							negritas: false,
							nombre: 'RIESGO FINANCIERO L/P SIN GARANTIAS REALES',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RIESGO FINANCIERO L/P CON GARANTIAS REALES',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RIESGO FINANCIERO C/P',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RIESGO COMERCIAL',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RIESGO DE FIRMA',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RIESGO DE TESORERÍA',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RIESGO DE TESORERÍA',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: true,
							nombre: 'TOTAL RIESGO CORPORATIVO',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'FINANCIACION ESPECIALIZADA',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'OTROS',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: true,
							nombre: 'TOTAL GRUPO',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'ASEGURAMIENTO DE RENTA FIJA (MARCO) (**)',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RIESGO MARCO EMISOR',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RIESGO DE LIQUIDACIÓN - FREE DELIVERY',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RIESGO DE LIQUIDACIÓN - DELIVERY vs. PAYMENT',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'OVERLIMITS, ACH',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RENTA VARIABLE',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'ASEGURAMIENTO DE RENTA VARIABLE',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'OTROS RIESGOS INDIRECTOS',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
					],
					posiciones_actuales: this.cliente.datos.posiciones_actuales,
					propuesta_de_riesgo: '',

					sociedades: [
						{
							nombre: '',
							rating: '',
							fecha_ejercicio: '',
							lte_autorizado: '',
						}
					],
					detalle_de_los_techos_autorizados_con_sus_respectivas_garantias: '',
					proyecto_de_inversion: '',
					etapas: '',
					credito_relacionado: '',
					persona_de_relevancia_publica: '',
					supuestos: '',
					se_estan_incluyendo_todos_los_riesgos_del_grupo_con_la_institucion: '',


					anterior_ambito_de_conformidad: '',
					proxima_revision_de_riesgos: '',
					motivo_proxima_revision: '',
					oficina_cr: '',
					comite_de_riesgos: '',
					director_de_oficina: '',
					fecha_de_sancion: '',
					ejecutivo_unidad_gestora: '',
					nombre_del_constraste: '',
					tipo_de_cambio_usd: '',
					decision: '',
					tipo_de_cambio_a_euro: '',
					comentario_politica_de_delegacion: '',

					rentabilidad_divisa: '',
					rentabilidad_datos_en: '',
					limites: [
						{
							nombre: 'IMPORTE NOMINAL',
							autorizado: '',
							actual: '',
							propuesto: '',
						},
					],
					perdida_esperada: [
						{
							nombre: '% s/Exposición',
							autorizado: '',
							actual: '',
							propuesto: '',
						},
						{
							nombre: 'Importe',
							autorizado: '',
							actual: '',
							propuesto: '',
						},
					],
					capital_economico: [
						{
							nombre: '% s/Exposición',
							autorizado: '',
							actual: '',
							propuesto: '',
						},
						{
							nombre: 'Importe',
							autorizado: '',
							actual: '',
							propuesto: '',
						},
						{
							nombre: 'RAR',
							autorizado: '',
							actual: '',
							propuesto: '',
						},
					],

					valoracion_y_opinion: '',

				}
				this.analisis.politicas.datos.estructura.push(cliente)
			}
		},
		setClientFinancialRisk() {
			if(!this.analisis.financial_risk.datos.estructura.length) {
				let cliente = JSON.stringify(this.cliente.datos)
					cliente = JSON.parse(cliente)
				cliente.datos =  {
					informes: [],
					consolidado: 'INDIVIDUAL',
					salvedades: '',
					auditor: '',
					divisa: 'Pesos Mexicanos',
					tipo_de_cambio_a_euro: '',
					tipo_de_cambio_dolar: '',
					comentario_perimetro_de_consolidacion_salvedades: '',
	
					balance_datos_en: 'Millones',
					balance_divisa: 'Pesos Mexicanos',
					// balance_datos: [],
					
					vencimiento_deuda_datos_en: 'Millones',
					vencimiento_deuda_divisa: 'Pesos Mexicanos',
					// vencimiento_deuda_datos: [],
					
					cuenta_resultados_datos_en: 'Millones',
					cuenta_resultados_divisa: 'Pesos Mexicanos',
					// cuenta_resultados_datos: [],
					
					cash_flow_datos_en: 'Millones',
					cash_flow_divisa: 'Pesos Mexicanos',
					// cash_flow_datos: [],
					
					magnitudes_ratios_datos_en: 'Millones',
					magnitudes_ratios_divisa: 'Pesos Mexicanos',
					// magnitudes_ratios_datos: [],
					
					comentarios_a_la_situacion_financiera_economica_y_valoracion_global: '',
					comentarios_sobre_cash_flow_magnitudes_y_ratios_flexibidad_y_liquidez: '',
	
					rating_datos: [
						{
							cabecera: '',
							score: '',
							escala_maestra: '',
							escala_larga: ''
						}
					],
					valoracion_del_rating_y_ajuste_del_rating: '',
	
					informacion_de_rating_local: [
						{
							nombre: '',
							numero_de_cte_pu: '',
							fecha_del_ejercicio: '',
							puntuacion_cuantitativa: '',
							puntuacion_cualitativa: '',
							puntuacion_total: '',
							escala_anterior: '',
							escala_actual: '',
						}
					],
	
					proyecciones_analisis_de_sensibilidad: ''
	
				}


				this.analisis.financial_risk.datos.estructura.push(cliente)
			}
		},
		showTab(event) {
			$('#datos_generales_tab').removeClass('active')
			$('#datos_generales_tab').removeAttr('aria-expanded')
			if(this.pendingChanges) {
				debugger
				this.$refs.saveChanges.open(null, function () {})
				this.lastTab = event.currentTarget
				return
			}
			let tab = event.currentTarget.getAttribute('href')
			// $(event.currentTarget).tab('show')
			$('.nav-link.active').removeClass('active')
			$(event.currentTarget).addClass('active')
			$('.tab-pane').removeClass('show active')
			$(tab).addClass('show active')
			this.hiddenSteps()

			let steps = event.currentTarget.dataset.step
			if(!steps) {
				return
			}
			this.showSteps(steps)
		},
		setAnalysis(data) {
			const vm = this
			for (const form in vm.analisis) {
				if(!data.hasOwnProperty(form)) {
					return 
				} 
				let dbData = data[form].datos
				let formData = vm.analisis[form].datos
				vm.analisis[form].avance = data[form].avance

				for (const key in formData) {
					if(!dbData.hasOwnProperty(key)) {
						return 
					} 
					let keyData = JSON.stringify(dbData[key])
						keyData = JSON.parse(keyData)
					vm.$set(formData, key, keyData)
				}


			}
		},
		getCompletion(name) {
			if(!this.cliente) 0
			if(!this.analisis.hasOwnProperty(name)) 0
			return this.analisis[name].avance || 0
		},

		goToModal(name = null, time = null) {
			this.$refs.loaderModal.open(3000, function () {
			})
		},

		formSave(data) {
			
			this.$refs.loaderModal.open(3000, function () {})
			this.$set(this.analisis[data.nombre], 'datos', data.datos)
			this.$set(this.analisis[data.nombre], 'avance', data.avance)

			let pf = JSON.stringify(this.pf)
				pf = JSON.parse(pf)
			
			pf.analysis = JSON.stringify(this.analisis)
			pf.analysis = JSON.parse(pf.analysis)

			this.updatePf(pf)
			this.pendingChanges = false
			if(this.lastTab) {
				$(this.lastTab).tab('show')
				this.lastTab = null
			}
			this.$refs.saveChanges.close()

			console.log(pf)

		},
		updatedForms() {
			this.pendingChanges = true
		},
		listenChanges() {
			$(this.$el).on('change', ':input', this.updatedForms)
		},
		saveChanges() {
			// const vm = this
			// let pf = JSON.stringify(this.pf)
			// 	pf = JSON.parse(pf)
			
			// pf.analysis = JSON.stringify(this.analisis)
			// pf.analysis = JSON.parse(pf.analysis)
			// this.updatePf(pf)
			// this.pendingChanges = false
			// this.$refs.saveChanges.close()

			// this.$refs.loaderModal.open(3000, function () {
			// 	if(vm.lastTab) {
			// 		$(vm.lastTab).tab('show')
			// 		vm.lastTab = null
			// 	}
			// })
			// basicData
			// generalData
			// businessRisk
			// financialRisk

			this.$refs.basicData.save()
			this.$refs.generalData.save()
			this.$refs.businessRisk.save()
			this.$refs.financialRisk.save()
			this.$refs.bankingRalationships.save()
			this.$refs.approachPf.save()
			this.$refs.politicsPf.save()

		},
		closeSaveChange() {
			this.$refs.saveChanges.close()
		},
		discardChanges() {
			this.pendingChanges = false
			let analysis = JSON.stringify(this.analisis)
				analysis = JSON.parse(analysis)
			
			this.$set(this, 'analisis', analysis)
			if(this.lastTab) {
				debugger
				$(this.lastTab).tab('show')
				this.lastTab = null
			}
			this.$refs.saveChanges.close()
		},
		openPrintModal() {
			this.$refs.printModal.open(null, null)
		},

		closePrintModal() {
			this.$refs.printModal.close(l)

		},
		openAcction() {
			this.goToStep('pfTabs', 4)
		},
		showendTab(event) {
			let $target = event.target
			let steps = $target.dataset.step
			this.showSteps(steps)
		},
		...mapActions({
			setAnalisys: 'pfAnalysis/setAnalisys',
			updatePf: 'pfAnalysis/updatePf'
		})
	},

	mounted() {
		let vm = this
		this.setAnalisys(this.$route.params.id)
		
		this.listenChanges()
		this.showSteps('pfTabs')

		setTimeout(function () {
			$('#actions').on('hidden.bs.dropdown', vm.hiddenSteps)
			$('[data-step]').on('shown.bs.tab', vm.showendTab)
		}, 2000)


	},

	beforeDestroy() {
		$(this.$el).off('change', ':input', this.updatedForms)
		$('#actions').off('hidden.bs.dropdown', this.hiddenSteps)
	}
}
</script>
<template>
	<div class="container">
		
		<pf-modal ref="saveChanges" title="Guardar cambios" class="pf-modal--md" :show-close="true">
			<div class="p-2">
				<p>¿Desea guardar los cambios?</p>
				<div class="d-flex flex-wrap justify-content-center">
					<button class="btn btn-primary btn-sm mx-2" @click="saveChanges">Aceptar</button>
					<button class="btn btn-primary btn-sm mx-2" @click="discardChanges">Descargar</button>
					<button class="btn btn-primary btn-sm mx-2" @click="closeSaveChange">Cancelar</button>
				</div>
			</div>
		</pf-modal>
		<pf-modal ref="loaderModal" title="Espere" @hook:mounted="goToModal">
			<div class="text-center p-2">
				<p>Realizando la operación seleccionada</p>
				<PfLoader />
			</div>
		</pf-modal>

		<pf-modal ref="printModal" :show-close="true" title="Imprimir" class="pf-modal--lg" >
			<div class="p-4">
				<div style="color: #000; font-size: 0.8rem; max-height: 500px; overflow: auto">
					<div class="pf-print" v-for="(opt,index) in printMenu" :key="`opt_${index}`">
						<div class="pf-print__item">
							<input type="checkbox">
							<img :src="`simulator/pf/${opt.tipo}.png`" alt="">
							<span :class="{'font-weight-bold': opt.tipo == 'folder' }">{{opt.nombre}}</span>
						</div>
						<div class="pf-print" v-for="(opt2,index) in opt.hijos" :key="`opt2_${index}`">
							<div class="pf-print__item" >
								<input type="checkbox">
								<img :src="`simulator/pf/${opt2.tipo}.png`" alt="">
								<span :class="{'font-weight-bold': opt2.tipo == 'folder' }">{{opt2.nombre}}</span>
							</div>
							<div class="pf-print" v-for="(opt3,index) in opt2.hijos" :key="`opt3_${index}`">
								<div class="pf-print__item" >
									<input type="checkbox">
									<img :src="`simulator/pf/${opt3.tipo}.png`" alt="">
									<span :class="{'font-weight-bold': opt3.tipo == 'folder' }">{{opt3.nombre}}</span>
								</div>
								<div class="pf-print" v-for="(opt4,index) in opt3.hijos" :key="`opt4_${index}`">
									<div class="pf-print__item" >
										<input type="checkbox">
										<img :src="`simulator/pf/${opt4.tipo}.png`" alt="">
										<span :class="{'font-weight-bold': opt4.tipo == 'folder' }">{{opt4.nombre}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-end">
					<button class="btn btn-sm btn-primary" @click="closePrintModal">Imprimir</button>
					<button class="btn btn-sm btn-primary ml-3" @click="closePrintModal">Cancelar</button>
				</div>
			</div>
		</pf-modal>
		<div v-if="pf && cliente">
			<h4 class="text-right text-primary m-0 font-weight-light mb-2" style="font-size: 1.3rem"> <router-link :to="{name: 'pf-index'}" class="text-primary"><span class="icon-home"></span></router-link> {{cliente.datos.nombre}} | {{cliente.hijos.length}} Clientes | <button class="btn btn-link" @click="getXLSXData"><i class="fa fa-download" aria-hidden="true"></i></button></h4>
			<ul class="nav nav-tabs pf-nav" id="myTab" role="tablist" data-v-step="pf_tabs_0">
				<li class="nav-item">
					<a class="nav-link" id="resumen_ejecutivo_tab" data-v-step="pf_tabs_0_2" @click.prevent="showTab" href="#resumen_ejecutivo" role="tab" aria-controls="resumen_ejecutivo" aria-selected="true">
						<span class="nav-title">Resumen Ejecutivo</span>
						<span class="nav-percent" >{{getCompletion('resumen_ejecutivo')}}%</span>
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link active" data-step="pfDB" id="datos_basicos_tab" @click.prevent="showTab" href="#datos_basicos" role="tab" aria-controls="datos_basicos" aria-selected="true">
						<span class="nav-title">Datos Básicos</span>
						<span class="nav-percent" data-v-step="pf_tabs_0_1">{{getCompletion('datos_basicos')}}%</span>
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" id="business_risk_tab" @click.prevent="showTab" href="#business_risk" role="tab" aria-controls="business_risk" aria-selected="true">
						<span class="nav-title">Business Risk</span>
						<span class="nav-percent">{{getCompletion('business_risk')}}%</span>
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" data-step="pfFR" id="financial_risk_tab" @click.prevent="showTab" href="#financial_risk" role="tab" aria-controls="financial_risk" aria-selected="true">
						<span class="nav-title">Financial Risk</span>
						<span class="nav-percent">{{getCompletion('financial_risk')}}%</span>
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" id="banking_relationships_tab" @click.prevent="showTab" href="#banking_relationships" role="tab" aria-controls="banking_relationships" aria-selected="true">
						<span class="nav-title">Relaciones Bancarias</span>
						<span class="nav-percent">{{getCompletion('relaciones_bancarias')}}%</span>
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" id="approach_pf_tab" @click.prevent="showTab" href="#approach_pf" role="tab" aria-controls="approach_pf" aria-selected="true">
						<span class="nav-title">Planteamiento</span>
						<span class="nav-percent">{{getCompletion('planteamiento')}}%</span>
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" data-step="pfP"  id="politics_pf_tab" @click.prevent="showTab" href="#politics_pf" role="tab" aria-controls="politics_pf" aria-selected="true">
						<span class="nav-title">Políticas</span>
						<span class="nav-percent">{{getCompletion('politicas')}}%</span>
					</a>
				</li>

				<li class="nav-item">
					<a class="nav-link" id="" >
						<div id="actions">
							<button class="nav-title dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-v-step="pf_tabs_1" @click="openAcction">
								Acciones
							</button>
							<div class="dropdown-menu dropdown-menu-right" data-v-step="pf_tabs_2">
								<a href="#" class="btn btn-primary btn-sm btn-block rounded-0">
									<span class="icon-route"></span> Trazabilidad
								</a>
								<a href="#" class="btn btn-primary btn-sm btn-block rounded-0" disabled>
									Resolución
								</a>
								<a href="#" class="btn btn-primary btn-sm btn-block rounded-0" disabled>
									<span class="icon-two-arrows-spin"></span> Reutilizar
								</a>
								<a href="#" class="btn btn-primary btn-sm btn-block rounded-0" @click="openPrintModal" data-v-step="pf_tabs_3">
									<span class="icon-printing"></span> Imprimir
								</a>
								<a href="#" class="btn btn-primary btn-sm btn-block rounded-0">
									<span class="icon-pdf-file"></span> Generar Informe Comité
								</a>
								<a id="datos_generales_tab" data-step="pfDG" @click.prevent="showTab" href="#datos_generales" role="tab" aria-controls="datos_generales" aria-selected="true" class="btn btn-primary btn-sm btn-block rounded-0"  data-v-step="pf_tabs_4">
									Datos Generales
								</a>
								<a href="#" class="btn btn-primary btn-sm btn-block rounded-0">
									<span class="icon-clip"></span> Documentación adjunta
								</a>
								<a href="#" class="btn btn-primary btn-sm btn-block rounded-0" disabled>
									<span class="icon-settings"></span> Acceso PLAN
								</a>
								<a href="#" class="btn btn-primary btn-sm btn-block rounded-0">
									Gestor de Impresiones
								</a>
								<a href="#" class="btn btn-primary btn-sm btn-block rounded-0">
								<span class="icon-trash"></span> Borrar
								</a>
							</div>
						</div>
					</a>
				</li>
			</ul>
			<div class="tab-content" id="forms">
				<div class="tab-pane fade " id="resumen_ejecutivo" role="tabpanel" aria-labelledby="resumen_ejecutivo_tab">
					<ExecutiveSummary :client="cliente" :analysis="{datos: analisis}" name="resumen" @save="formSave"/>
				</div>
				<div class="tab-pane fade show active" id="datos_basicos" role="tabpanel" aria-labelledby="datos_basicos_tab">
					<BasicData ref="basicData" :client="cliente" :analysis="analisis.datos_basicos" name="datos_basicos" @save="formSave"/>
				</div>
				<div class="tab-pane fade" id="datos_generales" role="tabpanel" aria-labelledby="datos_generales_tab">
					<GeneralData ref="generalData" :client="cliente" :analysis="analisis.datos_generales" name="datos_generales"  @save="formSave"/>
				</div>
				<div class="tab-pane fade" id="business_risk" role="tabpanel" aria-labelledby="business_risk_tab">
					<BusinessRisk ref="businessRisk" :client="cliente" :analysis="analisis.business_risk" name="business_risk"  @save="formSave"/>
				</div>
				<div class="tab-pane fade" id="financial_risk" role="tabpanel" aria-labelledby="financial_risk_tab">
					<FinancialRisk ref="financialRisk" :client="cliente" :analysis="analisis.financial_risk" name="financial_risk"  @save="formSave"/>
				</div>
				<div class="tab-pane fade" id="banking_relationships" role="tabpanel" aria-labelledby="banking_relationships_tab">
					<BankingRalationships ref="bankingRalationships" :client="cliente" :analysis="analisis.relaciones_bancarias" name="relaciones_bancarias"  @save="formSave"/>
				</div>
				<div class="tab-pane fade" id="approach_pf" role="tabpanel" aria-labelledby="approach_pf_tab">
					<ApproachPf ref="approachPf" :client="cliente" :analysis="analisis.planteamiento" name="planteamiento"  @save="formSave"/>
				</div>
				<div class="tab-pane fade" id="politics_pf" role="tabpanel" aria-labelledby="politics_pf_tab">
					<PoliticsPf ref="politicsPf" :client="cliente" :analysis="analisis.politicas" name="politicas"  @save="formSave"/>
				</div>
				<div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">...</div>
			</div>
		</div>
	</div>
</template>

